import React from "react";
import style from "../woundAssessment.module.scss";
import Loader from "../../../../static/images/spinner.svg";
import { Confirmation } from "../../../secondary";
import { Button } from "../../../primary";
import warning from "../../../../static/images/icon-check-danger.png";
import { useLoading } from "../../../../hooks/useLoading";
import { LOADING_KEYS } from "../../../../constants/loadingKeys";

const LockUnlockConfirmationModal = ({ setTogglePopup, toggleType, handleConfirm }) => {
  const signAndLockLoading = useLoading(LOADING_KEYS.SIGN_LOCK_LOADING);
  return (
    <Confirmation onClose={() => setTogglePopup(false)} title={" "}>
      <div className="text-center pr-5 pl-5">
        <p>
          <img src={warning} alt="warnning-icon" />
        </p>
        <p>
          {toggleType ? "Do you want to lock the assessments for this wound?" : "Do you want to unlock the assessments for this wound?"}
        </p>
        {signAndLockLoading && (
          <div className="loader p-0 pb-4">
            <img src={Loader} alt="loading" />
          </div>
        )}
        <div className="mb-2">
          <Button id="closeId" value="No" classes={{ className: `btn mr-4 pb-2 pt-2 ${style.no_btn}` }} onClick={() => setTogglePopup(false)} />
          <Button
            value="Yes"
            classes={{
              className: `btn mr-2 pb-2 pt-2 ml-2 ${style.yes_btn}`,
            }}
            onClick={handleConfirm}
          />
        </div>
      </div>
    </Confirmation>
  );
};

export default LockUnlockConfirmationModal;
